import isEmpty from 'lodash/isEmpty';
import { getAxisAdvancedPropertiesById, getHighchartCustomisationSettings, } from '../core/chart-model-utils';
import { AxisTypes } from '../types';
function discardAxisConfigOverrides(axisDetails, chartModel, styleConfig) {
    var _a, _b, _c;
    if (!styleConfig)
        return;
    const advancedAxisSettings = getAxisAdvancedPropertiesById(chartModel.vizProp, axisDetails.id);
    if (!advancedAxisSettings)
        return;
    if (!isEmpty((_b = (_a = advancedAxisSettings.axisSettings) === null || _a === void 0 ? void 0 : _a.axisName) === null || _b === void 0 ? void 0 : _b.fontSize)) {
        delete styleConfig.title.style.fontSize;
    }
    if (!isEmpty((_c = advancedAxisSettings === null || advancedAxisSettings === void 0 ? void 0 : advancedAxisSettings.labels) === null || _c === void 0 ? void 0 : _c.fontSize)) {
        delete styleConfig.labels.style.fontSize;
    }
}
export function discardConfigOverrides(chartModel, styleConfig) {
    var _a, _b, _c, _d, _e;
    chartModel.vizProp.axisProperties.forEach(axisDetails => {
        discardAxisConfigOverrides(axisDetails, chartModel, axisDetails.properties.axisType === AxisTypes.X
            ? styleConfig.xAxis
            : styleConfig.yAxis);
    });
    const advancedProperties = getHighchartCustomisationSettings(chartModel);
    if (!advancedProperties)
        return;
    const tooltipProps = advancedProperties.tooltip;
    if (!(isEmpty((_a = tooltipProps === null || tooltipProps === void 0 ? void 0 : tooltipProps.label) === null || _a === void 0 ? void 0 : _a.fontSize) ||
        isEmpty((_b = tooltipProps === null || tooltipProps === void 0 ? void 0 : tooltipProps.value) === null || _b === void 0 ? void 0 : _b.fontSize))) {
        delete styleConfig.tooltip.style.fontSize;
    }
    const xAxisGridlineProps = (_c = advancedProperties.gridlines) === null || _c === void 0 ? void 0 : _c.xAxis;
    if (styleConfig.xAxis && !isEmpty(xAxisGridlineProps === null || xAxisGridlineProps === void 0 ? void 0 : xAxisGridlineProps.gridLineWidth)) {
        delete styleConfig.xAxis.gridLineWidth;
    }
    const yAxisGridlineProps = (_d = advancedProperties.gridlines) === null || _d === void 0 ? void 0 : _d.yAxis;
    if (styleConfig.yAxis && !isEmpty(yAxisGridlineProps === null || yAxisGridlineProps === void 0 ? void 0 : yAxisGridlineProps.gridLineWidth)) {
        delete styleConfig.yAxis.gridLineWidth;
    }
    const answerLevelSettings = advancedProperties.answerLevelSettings;
    if (!isEmpty(answerLevelSettings === null || answerLevelSettings === void 0 ? void 0 : answerLevelSettings.lineWidth)) {
        delete styleConfig.plotOptions.line.lineWidth;
        delete styleConfig.plotOptions.line.states.hover.lineWidth;
    }
    if (!isEmpty(answerLevelSettings === null || answerLevelSettings === void 0 ? void 0 : answerLevelSettings.markerRadius)) {
        delete styleConfig.plotOptions.scatter.marker.radius;
    }
    const stackLabelStyles = advancedProperties.stackLabelStyles;
    if (!isEmpty((_e = stackLabelStyles === null || stackLabelStyles === void 0 ? void 0 : stackLabelStyles.style) === null || _e === void 0 ? void 0 : _e.fontSize)) {
        if (styleConfig.xAxis && styleConfig.xAxis.stackLabels) {
            delete styleConfig.xAxis.stackLabels.style.fontSize;
        }
        if (styleConfig.yAxis && styleConfig.yAxis.stackLabels) {
            delete styleConfig.yAxis.stackLabels.style.fontSize;
        }
    }
}
//# sourceMappingURL=blink-highchart-customisation-util.js.map